import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './layout/header/header.component';
import {PreloaderComponent} from './layout/preloader/preloader.component';
import {FooterComponent} from './layout/footer/footer.component';
import {HomeComponent} from './pages/home/home.component';
import {NewsComponent} from './pages/news/news.component';
import {SignUpComponent} from './pages/sign-up/sign-up.component';
import {SignInComponent} from './pages/sign-in/sign-in.component';
import {SellingComponent} from './pages/selling/selling.component';
import {PayoutttAppComponent} from './pages/payouttt-app/payouttt-app.component';
import {SignInUpFormComponent} from './pages/components/sign-in-up-form/sign-in-up-form.component';
import {PrivacyPolicyComponent} from './pages/privacy-policy/privacy-policy.component';
import {FaqComponent} from './pages/faq/faq.component';
import {ContactComponent} from './pages/contact/contact.component';
import {AboutUsComponent} from './pages/about-us/about-us.component';
import {BidComponent} from './pages/bid/bid.component';
import {BuyNowComponent} from './pages/buy-now/buy-now.component';
import {CartComponent} from './pages/cart/cart.component';
import {CategoriesDetailComponent} from './pages/categories-detail/categories-detail.component';
import {CheckoutComponent} from './pages/checkout/checkout.component';
import {ConfirmationComponent} from './pages/confirmation/confirmation.component';
import {NewsDetailComponent} from './pages/news-detail/news-detail.component';
import {SearchComponent} from './pages/search/search.component';
import {SellNowComponent} from './pages/sell-now/sell-now.component';
import {ThankYouComponent} from './pages/thank-you/thank-you.component';
import {ProductDetailComponent} from './pages/product-detail/product-detail.component';
import {SiteLayoutComponent} from './layout/site-layout/site-layout.component';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PreloaderComponent,
    FooterComponent,
    HomeComponent,
    NewsComponent,
    SignUpComponent,
    SignInComponent,
    SellingComponent,
    PayoutttAppComponent,
    SignInUpFormComponent,
    PrivacyPolicyComponent,
    FaqComponent,
    ContactComponent,
    AboutUsComponent,
    BidComponent,
    BuyNowComponent,
    CartComponent,
    CategoriesDetailComponent,
    CheckoutComponent,
    ConfirmationComponent,
    NewsDetailComponent,
    SearchComponent,
    SellNowComponent,
    ThankYouComponent,
    ProductDetailComponent,
    SiteLayoutComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production})
  ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { }
